<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <header class="brand-header">
    <img
      src="/beconfident-logo.png"
      :alt="t('brand.title')"
      class="brand-header__logo"
      width="662"
      height="89"
    />
  </header>
</template>

<style scoped>
.brand-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.brand-header__logo {
  height: 28px;
  width: auto;
  max-width: 70%;
  display: block;
}
</style>
